import { db, FieldValue } from 'helpers/firebase';
const serverTimestamp = FieldValue.serverTimestamp;


//CRUD

export const getDoc = (org_id, doc_id) => {
  const ref = db.doc(`/orgs/${org_id}/documents/${doc_id}`);
  return ref.get();
}

export const getDocs = (org_id) => {
  const ref = db.collection(`/orgs/${org_id}/documents`).orderBy('created_at', 'desc');
  return ref.get()
    .then(colSnap => colSnap.docs);
}

export const getDocsOfOrgRef = (org_id) => {
  const ref = db.collection(`/orgs/${org_id}/documents`)
    .orderBy('created_at', 'desc');
  return ref;
}

export const getDocsOfMemberRef = (org_id, user_id) => {
  const ref = db.collection(`/orgs/${org_id}/documents`)
    .where("target.uid", "==", user_id)
    .orderBy("created_at", "desc")
  return ref;
}

export const deleteDoc = (org_id, doc_id) => {
  const ref = db.doc(`/orgs/${org_id}/documents/${doc_id}`);
  return ref.delete();
}

export const updateDoc = (org_id, doc_id, data_to_update) => {
  const ref = db.doc(`/orgcs/${org_id}/documents/${doc_id}`);
  return ref.update(data_to_update);
}

export const createDoc = (org_id, doc_id, data_to_create) => {
  const ref = doc_id
    ? db.doc(`/orgs/${org_id}/documents/${doc_id}`)
    : db.collection(`/orgs/${org_id}/documents`).doc();

  console.log("data_to_create = ", data_to_create);
  return ref.set({
    ...data_to_create,
    created_at: serverTimestamp(),
    modified_at: serverTimestamp(),
  });
}

export const getNewDocId = (org_id) => {
  const ref = db.collection(`/orgs/${org_id}/documents`).doc();
  return ref.id;
}